// PERSONS
const GET_PERSONS_REQUEST = "GET_PERSONS_REQUEST";
const GET_PERSONS_COMPLETED = "GET_PERSONS_COMPLETED";
const GET_PERSONS_ERROR = "GET_PERSONS_ERROR";

const GET_PERSON_REQUEST = "GET_PERSON_REQUEST";
const GET_PERSON_COMPLETED = "GET_PERSON_COMPLETED";
const GET_PERSON_ERROR = "GET_PERSON_ERROR";

const GET_FULL_PERSON_REQUEST = "GET_FULL_PERSON_REQUEST";
const GET_FULL_PERSON_COMPLETED = "GET_FULL_PERSON_COMPLETED";
const GET_FULL_PERSON_ERROR = "GET_FULL_PERSON_ERROR";

const GET_SYSTEM_INFO_REQUEST = "GET_SYSTEM_INFO_REQUEST";
const GET_SYSTEM_INFO_COMPLETED = "GET_SYSTEM_INFO_COMPLETED";
const GET_SYSTEM_INFO_ERROR = "GET_SYSTEM_INFO_ERROR";

const GET_DOC_PERSON_REQUEST = "GET_DOC_PERSON_REQUEST";
const GET_DOC_PERSON_COMPLETED = "GET_DOC_PERSON_COMPLETED";
const GET_DOC_PERSON_ERROR = "GET_DOC_PERSON_ERROR";


const GET_MUNICIPALS_REQUEST = "GET_MUNICIPALS_REQUEST";
const GET_MUNICIPALS_COMPLETED = "GET_MUNICIPALS_COMPLETED";
const GET_MUNICIPALS_ERROR = "GET_MUNICIPALS_ERROR";

const GET_ORGANIZATIONS_REQUEST = "GET_ORGANIZATIONS_REQUEST";
const GET_ORGANIZATIONS_COMPLETED = "GET_ORGANIZATIONS_COMPLETED";
const GET_ORGANIZATIONS_ERROR = "GET_ORGANIZATIONS_ERROR";

/*const GET_POSTS_REQUEST = "GET_POSTS_REQUEST";
const GET_POSTS_COMPLETED = "GET_POSTS_COMPLETED";
const GET_POSTS_ERROR = "GET_POSTS_ERROR";*/

const GET_PERSON_ROLES_REQUEST = "GET_PERSON_ROLES_REQUEST";
const GET_PERSON_ROLES_COMPLETED = "GET_PERSON_ROLES_COMPLETED";
const GET_PERSON_ROLES_ERROR = "GET_PERSON_ROLES_ERROR";

const GET_PERSON_WS_REQUEST = "GET_PERSON_WS_REQUEST";
const GET_PERSON_WS_COMPLETED = "GET_PERSON_WS_COMPLETED";
const GET_PERSON_WS_ERROR = "GET_PERSON_WS_ERROR";

const GET_PERSON_SKILLS_REQUEST = "GET_PERSON_SKILLS_REQUEST";
const GET_PERSON_SKILLS_COMPLETED = "GET_PERSON_SKILLS_COMPLETED";
const GET_PERSON_SKILLS_ERROR = "GET_PERSON_SKILLS_ERROR";

const GET_PERSON_ORGANIZATIONS_REQUEST = "GET_PERSON_ORGANIZATIONS_REQUEST";
const GET_PERSON_ORGANIZATIONS_COMPLETED = "GET_PERSON_ORGANIZATIONS_COMPLETED";
const GET_PERSON_ORGANIZATIONS_ERROR = "GET_PERSON_ORGANIZATIONS_ERROR";

const GET_PERSON_DOCUMENT_ATTACHMENTS_REQUEST = "GET_PERSON_DOCUMENT_ATTACHMENTS_REQUEST";
const GET_PERSON_DOCUMENT_ATTACHMENTS_COMPLETED = "GET_PERSON_DOCUMENT_ATTACHMENTS_COMPLETED";
const GET_PERSON_DOCUMENT_ATTACHMENTS_ERROR = "GET_PERSON_DOCUMENT_ATTACHMENTS_ERROR";

const GET_PERSON_SNILS_ATTACHMENTS_REQUEST = "GET_PERSON_SNILS_ATTACHMENTS_REQUEST";
const GET_PERSON_SNILS_ATTACHMENTS_COMPLETED = "GET_PERSON_SNILS_ATTACHMENTS_COMPLETED";
const GET_PERSON_SNILS_ATTACHMENTS_ERROR = "GET_PERSON_SNILS_ATTACHMENTS_ERROR";

const GET_DEPARTMENTS_REQUEST = "GET_DEPARTMENTS_REQUEST";
const GET_DEPARTMENTS_COMPLETED = "GET_DEPARTMENTS_COMPLETED";
const GET_DEPARTMENTS_ERROR = "GET_DEPARTMENTS_ERROR";

const GET_PERSON_HISTORY_REQUEST = "GET_PERSON_HISTORY_REQUEST";
const GET_PERSON_HISTORY_COMPLETED = "GET_PERSON_HISTORY_COMPLETED";
const GET_PERSON_HISTORY_ERROR = "GET_PERSON_HISTORY_ERROR";

const IMPORT_PERSONS_REQUEST = "IMPORT_PERSONS_REQUEST";
const IMPORT_PERSONS_COMPLETED = "IMPORT_PERSONS_COMPLETED";
const IMPORT_PERSONS_ERROR = "IMPORT_PERSONS_ERROR";

const UPDATE_PERSON_REQUEST = "UPDATE_PERSON_REQUEST";
const UPDATE_PERSON_COMPLETED = "UPDATE_PERSON_COMPLETED";
const UPDATE_PERSON_ERROR = "UPDATE_PERSON_ERROR";

const UPDATE_PERSON_ROLES_REQUEST = "UPDATE_PERSON_ROLES_REQUEST";
const UPDATE_PERSON_ROLES_COMPLETED = "UPDATE_PERSON_ROLES_COMPLETED";
const UPDATE_PERSON_ROLES_ERROR = "UPDATE_PERSON_ROLES_ERROR";

const CREATE_PERSON_REQUEST = "CREATE_PERSON_REQUEST";
const CREATE_PERSON_COMPLETED = "CREATE_PERSON_COMPLETED";
const CREATE_PERSON_ERROR = "CREATE_PERSON_ERROR";

const BLOCK_PERSON_REQUEST = "BLOCK_PERSON_REQUEST";
const BLOCK_PERSON_COMPLETED = "BLOCK_PERSON_COMPLETED";
const BLOCK_PERSON_ERROR = "BLOCK_PERSON_ERROR";

const ADD_ATTACHMENTS_COMPLETED = "ADD_ATTACHMENTS_COMPLETED";
const ADD_ATTACHMENTS_ERROR = "ADD_ATTACHMENTS_ERROR";

const ADD_ATTACHMENTS_SNILS_COMPLETED = "ADD_ATTACHMENTS_SNILS_COMPLETED";
const ADD_ATTACHMENTS_SNILS_ERROR = "ADD_ATTACHMENTS_SNILS_ERROR";

const UPDATE_PERSON_AVATAR_REQUEST = "UPDATE_PERSON_AVATAR_REQUEST";
const UPDATE_PERSON_AVATAR_COMPLETED = "UPDATE_PERSON_AVATAR_COMPLETED";
const UPDATE_PERSON_AVATAR_ERROR = "UPDATE_PERSON_AVATAR_ERROR";

const DELETE_PERSONS_REQUEST = "DELETE_PERSONS_REQUEST";
const DELETE_PERSONS_COMPLETED = "DELETE_PERSONS_COMPLETED";
const DELETE_PERSONS_ERROR = "DELETE_PERSONS_ERROR";

const DELETE_ATTACHMENT_REQUEST = "DELETE_ATTACHMENT_REQUEST";
const DELETE_ATTACHMENT_COMPLETED = "DELETE_ATTACHMENT_COMPLETED";
const DELETE_ATTACHMENT_ERROR = "DELETE_ATTACHMENT_ERROR";

export default {
  GET_PERSONS_REQUEST,
  GET_PERSONS_COMPLETED,
  GET_PERSONS_ERROR,
  GET_PERSON_REQUEST,
  GET_PERSON_COMPLETED,
  GET_PERSON_ERROR,
  GET_FULL_PERSON_REQUEST,
  GET_FULL_PERSON_COMPLETED,
  GET_FULL_PERSON_ERROR,
  GET_DOC_PERSON_REQUEST,
  GET_DOC_PERSON_COMPLETED,
  GET_DOC_PERSON_ERROR,
  GET_MUNICIPALS_REQUEST,
  GET_MUNICIPALS_COMPLETED,
  GET_MUNICIPALS_ERROR,
  GET_PERSON_DOCUMENT_ATTACHMENTS_REQUEST,
  GET_PERSON_DOCUMENT_ATTACHMENTS_COMPLETED,
  GET_PERSON_DOCUMENT_ATTACHMENTS_ERROR,
  GET_PERSON_SNILS_ATTACHMENTS_REQUEST,
  GET_PERSON_SNILS_ATTACHMENTS_COMPLETED,
  GET_PERSON_SNILS_ATTACHMENTS_ERROR,
  GET_PERSON_ROLES_REQUEST,
  GET_PERSON_ROLES_COMPLETED,
  GET_PERSON_ROLES_ERROR,
  GET_PERSON_WS_REQUEST,
  GET_PERSON_WS_COMPLETED,
  GET_PERSON_WS_ERROR,
  GET_PERSON_SKILLS_REQUEST,
  GET_PERSON_SKILLS_COMPLETED,
  GET_PERSON_SKILLS_ERROR,
  GET_SYSTEM_INFO_REQUEST,
  GET_SYSTEM_INFO_COMPLETED,
  GET_SYSTEM_INFO_ERROR,
  GET_ORGANIZATIONS_REQUEST,
  GET_ORGANIZATIONS_COMPLETED,
  GET_ORGANIZATIONS_ERROR,
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_COMPLETED,
  GET_DEPARTMENTS_ERROR,
  /*GET_POSTS_REQUEST,
  GET_POSTS_COMPLETED,
  GET_POSTS_ERROR,*/
  GET_PERSON_HISTORY_REQUEST,
  GET_PERSON_HISTORY_COMPLETED,
  GET_PERSON_HISTORY_ERROR,

  ADD_ATTACHMENTS_COMPLETED,
  ADD_ATTACHMENTS_ERROR,
  ADD_ATTACHMENTS_SNILS_COMPLETED,
  ADD_ATTACHMENTS_SNILS_ERROR,
  UPDATE_PERSON_REQUEST,
  UPDATE_PERSON_COMPLETED,
  UPDATE_PERSON_ERROR,
  UPDATE_PERSON_ROLES_REQUEST,
  UPDATE_PERSON_ROLES_COMPLETED,
  UPDATE_PERSON_ROLES_ERROR,
  CREATE_PERSON_REQUEST,
  CREATE_PERSON_COMPLETED,
  CREATE_PERSON_ERROR,
  IMPORT_PERSONS_REQUEST,
  IMPORT_PERSONS_COMPLETED,
  IMPORT_PERSONS_ERROR,
  BLOCK_PERSON_REQUEST,
  BLOCK_PERSON_COMPLETED,
  BLOCK_PERSON_ERROR,
  UPDATE_PERSON_AVATAR_REQUEST,
  UPDATE_PERSON_AVATAR_COMPLETED,
  UPDATE_PERSON_AVATAR_ERROR,

  DELETE_PERSONS_REQUEST,
  DELETE_PERSONS_COMPLETED,
  DELETE_PERSONS_ERROR,
  DELETE_ATTACHMENT_REQUEST,
  DELETE_ATTACHMENT_COMPLETED,
  DELETE_ATTACHMENT_ERROR,

  GET_PERSON_ORGANIZATIONS_REQUEST,
  GET_PERSON_ORGANIZATIONS_COMPLETED,
  GET_PERSON_ORGANIZATIONS_ERROR
}
